package co.torvus.web

import web.cssom.ClassName

/** Joins non-blank class names into a single [ClassName] (for conditional/active classes). */
internal fun classes(vararg parts: String?): ClassName =
    ClassName(parts.asSequence().filterNotNull().filter { it.isNotBlank() }.joinToString(" "))
